// extracted by mini-css-extract-plugin
module.exports = {"socialShareWrapper":"socialShare_socialShareWrapper__75zX6"};